import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
  Alert
} from '@mui/material';
import {
  Block as BlockIcon,
  Home as HomeIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: 'center',
            maxWidth: 500,
            width: '100%'
          }}
        >
          <Box sx={{ mb: 3 }}>
            <BlockIcon
              sx={{
                fontSize: 80,
                color: 'error.main',
                mb: 2
              }}
            />
            <Typography variant="h3" component="h1" gutterBottom>
              403
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom color="error">
              Access Denied
            </Typography>
          </Box>

          <Typography variant="body1" paragraph color="text.secondary">
            You don't have permission to access this resource.
          </Typography>

          {user && (
            <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
              <Typography variant="body2">
                <strong>Current User:</strong> {user.firstName} {user.lastName}<br />
                <strong>Email:</strong> {user.email}<br />
                <strong>Role:</strong> {user.roles?.join(', ') || 'No roles assigned'}<br />
                <strong>Tenant:</strong> {user.tenantName}<br />
                <strong>Permissions:</strong> {user.permissions?.length || 0} permissions
                {user.permissions && user.permissions.length > 0 && (
                  <Box component="span" sx={{ display: 'block', mt: 1, fontSize: '0.8em' }}>
                    {user.permissions.join(', ')}
                  </Box>
                )}
              </Typography>
            </Alert>
          )}

          <Typography variant="body2" paragraph color="text.secondary">
            If you believe this is an error, please contact your system administrator.
          </Typography>

          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{ mt: 2 }}
          >
            Go to Dashboard
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Unauthorized;